module.exports = __webpack_public_path__ + "static/media/event-2.575addff.jpg";